import React from "react";

import type { RightPaneState } from "../../app/state/right-pane/RightPaneState";

import { RightPaneBoundaryContextProvider } from "./_context";

export interface RightPaneBoundaryProps {
	state: RightPaneState;
}

export const RightPaneBoundary: React.FC<React.PropsWithChildren<RightPaneBoundaryProps>> = ({ state, children }) => (
	<RightPaneBoundaryContextProvider value={state}>{children}</RightPaneBoundaryContextProvider>
);
